'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _Reagan = require('../constants/Reagan');

var _Checker = require('Reagan/components/Checker');

var _WidgetActions = require('../actions/WidgetActions');

var _widgetDataReceived = require('../actions/widgetDataReceived');

var _refreshWidgetData = require('../widget-data/actions/refreshWidgetData');

var _WindowActions = require('../actions/WindowActions');

var _handleIframeResize = require('../post-message/actions/handleIframeResize');

var _handleClosedWelcomeMessage = require('../post-message/actions/handleClosedWelcomeMessage');

var _handleRequestWidget = require('../post-message/actions/handleRequestWidget');

var _getIsOpen = require('../selectors/getIsOpen');

var _getIsMobile = require('../selectors/getIsMobile');

var _Application = require('../components/Application');

var _Application2 = _interopRequireDefault(_Application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapStateToProps = function mapStateToProps(state) {
  var prospectUtks = state.prospectUtks,
      requestStatus = state.requestStatus;


  return {
    prospectUtks: prospectUtks,
    widgetDataStatus: requestStatus.widgetData,
    isOpen: (0, _getIsOpen.getIsOpen)(state),
    mobile: (0, _getIsMobile.getIsMobile)(state)
  };
};

var mapDispatchToProps = {
  handleIframeResize: _handleIframeResize.handleIframeResize,
  handleClosedWelcomeMessage: _handleClosedWelcomeMessage.handleClosedWelcomeMessage,
  handleRequestWidget: _handleRequestWidget.handleRequestWidget,
  setWindowVisible: _WindowActions.setWindowVisible,
  widgetDataReceived: _widgetDataReceived.widgetDataReceived,
  refreshWidgetData: _refreshWidgetData.refreshWidgetData,
  toggleOpen: _WidgetActions.toggleOpen
};

exports.default = (0, _pipe2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _Checker.checker)({
  selectors: {
    success: _defineProperty({}, _Reagan.CHECKS.VISITOR_SUCCESS, _Reagan.SELECTORS.VISITOR_SUCCESS),
    error: _defineProperty({}, _Reagan.CHECKS.VISITOR_ERROR, _Reagan.SELECTORS.VISITOR_ERROR)
  }
}))(_Application2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/containers/ApplicationContainer.js
// module id = 1285
// module chunks = 3